export default "__VITE_ASSET__DAqYSSNN__"